<div class="my-4 row">
    <ng-container *ngIf="!basket.voucher">
        <div class="d-flex justify-content-between">
            <div class="enter-input-code">
                <input type="text" class="form-control form-control-thin w-100 me-3" (keydown)="hideErrorMessage()"
                    [(ngModel)]="basket.voucherCodeEntered" placeholder="Enter code"
                    [disabled]="!!basket.discount.value" />
                <i class="fa fa-tags white-tag placeholder-icon"></i>
            </div>
            <div class="d-flex align-items-center h-100">
                <button (click)="applyVoucher()" [disabled]="!!basket.discount.value" type="button"
                    class="btn btn-primary btn-thin apply-btn">
                    Apply
                </button>
            </div>
        </div>
        <p class="text-danger" *ngIf="voucherError">{{voucherError}}</p>
    </ng-container>
    <ng-container *ngIf="basket.voucher">
        <div class="d-flex flex-column mb-1">
            <div class="d-flex justify-content-between">
                <div class="ff-spectral fs-5 w-75">
                    <span>Coupon applied: </span>
                    <span class="fw-bold">{{basket.voucher.code}}</span>
                </div>
                <div class="ff-spectral fs-5 text-end w-25">
                    -{{basket.values.voucherDiscount | yssCurrency}}
                </div>
            </div>
            <div class="ff-spectral small hover">
                <a (click)="removeVoucher()">Remove coupon</a>
            </div>
        </div>
    </ng-container>
</div>